var a;class e{}a=e,e.isDataLayerSet=()=>"undefined"!=typeof dataLayer,e.push=e=>{a.isDataLayerSet()&&dataLayer.push(e)};export{e as GtmBaseService};
